export const SelectedCandidates = (state: number[] = [], action: any) => {
  switch (action.type) {
    case "SELECTED_CANDIDATES":
      return action.payload;
    default:
      return state;
  }
};
